(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_react__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./packages/text-input-error/src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/css-loader/dist/cjs.js?!./node_modules/sass-loader/dist/cjs.js!./packages/text-input-error/src/TextInputError.module.scss":
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js??ref--5-1!./node_modules/sass-loader/dist/cjs.js!./packages/text-input-error/src/TextInputError.module.scss ***!
  \*********************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(/*! ../../../node_modules/css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.i, "@keyframes _38RLtrmrP9HcFD6E_0UZlP {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes yEwQBLTgFFZFCA1PsJig- {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes _2rtekbTs_98iVsxEDvyVpd {\n  0% {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n._1MSxO77oMhfOPnM8i5RH4f {\n  margin-top: 10px;\n  color: #c90036;\n  opacity: 0;\n}\n@media screen and (min-width: 1px) {\n  ._1MSxO77oMhfOPnM8i5RH4f {\n    font-size: 14px;\n    letter-spacing: -0.3px;\n    line-height: 1.5;\n  }\n}\n@media screen and (min-width: 320px) {\n  ._1MSxO77oMhfOPnM8i5RH4f {\n    font-size: 14px;\n    letter-spacing: -0.3px;\n    line-height: 1.5;\n  }\n}\n@media screen and (min-width: 375px) {\n  ._1MSxO77oMhfOPnM8i5RH4f {\n    font-size: 14px;\n    letter-spacing: -0.3px;\n    line-height: 1.5;\n  }\n}\n@media screen and (min-width: 768px) {\n  ._1MSxO77oMhfOPnM8i5RH4f {\n    font-size: 14px;\n    letter-spacing: -0.3px;\n    line-height: 1.5;\n  }\n}\n@media screen and (min-width: 920px) {\n  ._1MSxO77oMhfOPnM8i5RH4f {\n    font-size: 14px;\n    letter-spacing: -0.3px;\n    line-height: 1.5;\n  }\n}\n@media screen and (min-width: 1024px) {\n  ._1MSxO77oMhfOPnM8i5RH4f {\n    font-size: 14px;\n    letter-spacing: -0.47px;\n    line-height: 1.29;\n  }\n}\n@media screen and (min-width: 1260px) {\n  ._1MSxO77oMhfOPnM8i5RH4f {\n    font-size: 14px;\n    letter-spacing: -0.47px;\n    line-height: 1.29;\n  }\n}\n@media screen and (min-width: 1440px) {\n  ._1MSxO77oMhfOPnM8i5RH4f {\n    font-size: 14px;\n    letter-spacing: -0.47px;\n    line-height: 1.29;\n  }\n}\n.aB5APzdh3Od1CZhcPRe-B {\n  animation: _38RLtrmrP9HcFD6E_0UZlP 0.2s;\n  animation-delay: 0.2s;\n  animation-fill-mode: forwards;\n}\n._32NFQMvVPQcF3DyNKbZu3- {\n  animation: yEwQBLTgFFZFCA1PsJig- 0.2s;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textInputError": "_1MSxO77oMhfOPnM8i5RH4f",
	"textInputErrorFadeIn": "aB5APzdh3Od1CZhcPRe-B",
	"fadeIn": "_38RLtrmrP9HcFD6E_0UZlP",
	"textInputErrorFadeOut": "_32NFQMvVPQcF3DyNKbZu3-",
	"fadeOut": "yEwQBLTgFFZFCA1PsJig-",
	"fadeInUp": "_2rtekbTs_98iVsxEDvyVpd"
};
module.exports = ___CSS_LOADER_EXPORT___;


/***/ }),

/***/ "./node_modules/css-loader/dist/runtime/api.js":
/*!*****************************************************!*\
  !*** ./node_modules/css-loader/dist/runtime/api.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join("");
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === "string") {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, ""]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ "./node_modules/iso-morphic-style-loader/lib/addUniversalStyles.js":
/*!*************************************************************************!*\
  !*** ./node_modules/iso-morphic-style-loader/lib/addUniversalStyles.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var StyleElement = __webpack_require__(/*! ./styleElement */ "./node_modules/iso-morphic-style-loader/lib/styleElement.js")

var memoize = function(fn) {
  var memo;

  return function() {
    if (typeof memo === "undefined") memo = fn.apply(this, arguments);
    return memo;
  };
};

var isOldIE; // IE <= 9
var flagAttr = "data-universal";
var flagAttrValue = "ssr";
// Used during server side to store loaded style.
var serverStyles = [];
// Indicate whether a style processed.
var stylesInDom = {};
var singleton = null;
var singletonCounter = 0;
var getElement;
var stylesInsertedAtTop = [];
var fixUrls;

function noop() {}

/**
 * Ignored options: options.insertInto | options.insertAt
 */
module.exports = function(list, options) {
  options = options || {};

  options.attrs = typeof options.attrs === "object" ? options.attrs : {};

  var styles = listToStyles(list, options);

  // reset
  noop.__universal__ = undefined;

  // If in server env, export styles to global if user want to inject to html.
  if (typeof window !== "object" || !window.document) {
    isOldIE = memoize(function() {
      if (typeof navigator === "object" && navigator.userAgent) {
        return /MSIE [5-9]\b/i.test(navigator.userAgent);
      }
      return false;
    });
    if (!options.singleton) options.singleton = isOldIE();
    return handleStylesForSsr(styles, options);
  } else {
    isOldIE = memoize(function() {
      return window && document && document.all && !window.atob;
    });
  }

  // Now in browser side, do almost the same as original style-loader.
  if (!options.singleton) options.singleton = isOldIE();
  // By default, add <style> tags to the <head> element
  if (!options.insertInto) options.insertInto = "head";

  // By default, add <style> tags to the bottom of the target
  if (!options.insertAt) options.insertAt = "bottom";

  fixUrls = __webpack_require__(/*! ./urls */ "./node_modules/iso-morphic-style-loader/lib/urls.js");
  getElement = (function(fn) {
    var memo = {};

    return function(selector) {
      if (typeof memo[selector] === "undefined") {
        var styleTarget = fn.call(this, selector);
        // Special case to return head of iframe instead of iframe itself
        if (styleTarget instanceof window.HTMLIFrameElement) {
          try {
            // This will throw an exception if access to iframe is blocked
            // due to cross-origin restrictions
            styleTarget = styleTarget.contentDocument.head;
          } catch (e) {
            styleTarget = null;
          }
        }
        memo[selector] = styleTarget;
      }
      return memo[selector]
    };
  })(function(target) {
    return document.querySelector(target)
  });

  addStylesToDom(styles, options);

  // Check if has the same style inserted by server, and remove it.
  setTimeout(cleanDomStyles, 16);

  return function update(newList) {
    var mayRemove = [];

    for (var i = 0; i < styles.length; i++) {
      var item = styles[i];
      var domStyle = stylesInDom[item.id];

      domStyle.refs--;
      mayRemove.push(domStyle);
    }

    if (newList) {
      var newStyles = listToStyles(newList, options);
      addStylesToDom(newStyles, options);
    }

    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i];

      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

        delete stylesInDom[domStyle.id];
      }
    }
  };
};

function cleanDomStyles() {
  var allStyles = [].slice.call(document.getElementsByTagName("style"), 0);
  var item;
  for (var i = 0; i < allStyles.length; i++) {
    item = allStyles[i];
    if (item.getAttribute(flagAttr) === flagAttrValue) {
      item.parentNode.removeChild(item);
    }
  }
}

function handleStylesForSsr(styles, options) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i];
    for (var j = 0; j < item.parts.length; j++) {
      addUniversalStyle(item.parts[j], options, item.id);
    }
  }

  // Export for ssr.
  noop.__universal__ = serverStyles;
  return noop;

  function addUniversalStyle(obj, options, id) {
    var style, result;

    // Do transform, and if return null, it means we should ignore this style.
    if (options.transform && obj.css) {
      result = options.transform(obj.css);
      if (result) {
        obj.css = result;
      } else {
        return noop;
      }
    }

    // Set attrs.type to `text/css`.
    options.attrs.type = "text/css";
    // Indicate that the style is insetred during ssr time.
    options.attrs[flagAttr] = flagAttrValue;

    if (options.singleton) {
      var styleIndex = singletonCounter++;
      options.attrs["data-singleton"] = "singleton";
      style = singleton || (singleton = createStyle(options, id));
      style.content.splice(styleIndex, 1, obj.css);
      if (serverStyles.indexOf(style) === -1) {
        serverStyles.push(style);
      }
    } else {
      style = createStyle(options, id);
      style.content.push(obj.css)
      if (obj.media) {
        style.setAttribute("media", obj.media)
      }
      serverStyles.push(style);
    }

    return noop;
  }

  function createStyle(options, id) {
    var style = new StyleElement(id);
    Object.keys(options.attrs).forEach(function(key) {
      style.setAttribute(key, options.attrs[key]);
    });
    return style;
  }
}

/// Used by both side.
function listToStyles(list, options) {
  var styles = [];
  var newStyles = {};

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      css: css,
      media: media,
      sourceMap: sourceMap
    };

    if (!newStyles[id]) styles.push(newStyles[id] = {
      id: id,
      parts: [part]
    });
    else newStyles[id].parts.push(part);
  }

  return styles;
}

/// Functions from original addStyles.js, only used by browser side.
function addStylesToDom(styles, options) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i];
    var domStyle = stylesInDom[item.id];

    if (domStyle) {
      domStyle.refs++;

      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j]);
      }

      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j], options));
      }
    } else {
      var parts = [];

      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j], options));
      }

      stylesInDom[item.id] = {
        id: item.id,
        refs: 1,
        parts: parts
      };
    }
  }
}

function insertStyleElement(options, style) {
  var target = getElement(options.insertInto)

  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
  }

  var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

  if (options.insertAt === "top") {
    if (!lastStyleElementInsertedAtTop) {
      target.insertBefore(style, target.firstChild);
    } else if (lastStyleElementInsertedAtTop.nextSibling) {
      target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
    } else {
      target.appendChild(style);
    }
    stylesInsertedAtTop.push(style);
  } else if (options.insertAt === "bottom") {
    target.appendChild(style);
  } else {
    throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
  }
}

function removeStyleElement(style) {
  if (style.parentNode === null) return false;
  style.parentNode.removeChild(style);

  var idx = stylesInsertedAtTop.indexOf(style);
  if (idx >= 0) {
    stylesInsertedAtTop.splice(idx, 1);
  }
}

function createStyleElement(options) {
  var style = document.createElement("style");

  options.attrs.type = "text/css";

  addAttrs(style, options.attrs);
  insertStyleElement(options, style);

  return style;
}

function createLinkElement(options) {
  var link = document.createElement("link");

  options.attrs.type = "text/css";
  options.attrs.rel = "stylesheet";

  addAttrs(link, options.attrs);
  insertStyleElement(options, link);

  return link;
}

function addAttrs(el, attrs) {
  Object.keys(attrs).forEach(function(key) {
    el.setAttribute(key, attrs[key]);
  });
}

function addStyle(obj, options) {
  var style, update, remove, result;

  // If a transform function was defined, run it on the css
  if (options.transform && obj.css) {
    result = options.transform(obj.css);

    if (result) {
      // If transform returns a value, use that instead of the original css.
      // This allows running runtime transformations on the css.
      obj.css = result;
    } else {
      // If the transform function returns a falsy value, don't add this css.
      // This allows conditional loading of css
      return function() {};
    }
  }

  if (options.singleton) {
    var styleIndex = singletonCounter++;

    style = singleton || (singleton = createStyleElement(options));

    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);

  } else if (
    obj.sourceMap &&
    typeof URL === "function" &&
    typeof URL.createObjectURL === "function" &&
    typeof URL.revokeObjectURL === "function" &&
    typeof Blob === "function" &&
    typeof btoa === "function"
  ) {
    style = createLinkElement(options);
    update = updateLink.bind(null, style, options);
    remove = function() {
      removeStyleElement(style);

      if (style.href) URL.revokeObjectURL(style.href);
    };
  } else {
    style = createStyleElement(options);
    update = applyToTag.bind(null, style);
    remove = function() {
      removeStyleElement(style);
    };
  }

  update(obj);

  return function updateStyle(newObj) {
    if (newObj) {
      if (
        newObj.css === obj.css &&
        newObj.media === obj.media &&
        newObj.sourceMap === obj.sourceMap
      ) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

var replaceText = (function() {
  var textStore = [];

  return function(index, replacement) {
    textStore[index] = replacement;

    return textStore.filter(Boolean).join("\n");
  };
})();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? "" : obj.css;

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) style.removeChild(childNodes[index]);

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, obj) {
  var css = obj.css;
  var media = obj.media;

  if (media) {
    style.setAttribute("media", media)
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

function updateLink(link, options, obj) {
  var css = obj.css;
  var sourceMap = obj.sourceMap;

  /*
  	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
  	and there is no publicPath defined then lets turn convertToAbsoluteUrls
  	on by default.  Otherwise default to the convertToAbsoluteUrls option
  	directly
  */
  var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

  if (options.convertToAbsoluteUrls || autoFixUrls) {
    css = fixUrls(css);
  }

  if (sourceMap) {
    // http://stackoverflow.com/a/26603875
    css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
  }

  var blob = new Blob([css], {
    type: "text/css"
  });

  var oldSrc = link.href;

  link.href = URL.createObjectURL(blob);

  if (oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "./node_modules/iso-morphic-style-loader/lib/styleElement.js":
/*!*******************************************************************!*\
  !*** ./node_modules/iso-morphic-style-loader/lib/styleElement.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function StyleElement (id) {
  this.id = id;
  this.content = [];
  this.attrs = {};
}

StyleElement.prototype.setAttribute = function (key, value) {
  if (value == null) {
    delete this.attrs[key];
  } else {
    this.attrs[key] = value;
  }
}

StyleElement.prototype.toString = function (connector) {
  var content = this.content.join(connector == null ? '\n' : connector);
  var attrStr = '';
  var attrs = this.attrs;

  Object.keys(this.attrs).forEach(function (v) {
    attrStr += v + '="' + attrs[v] + '" ';
  });
  if (attrStr.length > 0) {
    attrStr = ' ' + attrStr.slice(0, -1);
  }
  return '<style' + attrStr + '>' + content + '</style>';
}

module.exports = StyleElement;


/***/ }),

/***/ "./node_modules/iso-morphic-style-loader/lib/urls.js":
/*!***********************************************************!*\
  !*** ./node_modules/iso-morphic-style-loader/lib/urls.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "./packages/text-input-error/src/TextInputError.module.scss":
/*!******************************************************************!*\
  !*** ./packages/text-input-error/src/TextInputError.module.scss ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../node_modules/css-loader/dist/cjs.js??ref--5-1!../../../node_modules/sass-loader/dist/cjs.js!./TextInputError.module.scss */ "./node_modules/css-loader/dist/cjs.js?!./node_modules/sass-loader/dist/cjs.js!./packages/text-input-error/src/TextInputError.module.scss");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../node_modules/iso-morphic-style-loader/lib/addUniversalStyles.js */ "./node_modules/iso-morphic-style-loader/lib/addUniversalStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
module.exports.__universal__ = update.__universal__;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ "./packages/text-input-error/src/TextInputError.tsx":
/*!**********************************************************!*\
  !*** ./packages/text-input-error/src/TextInputError.tsx ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
var react_animate_height_1 = __importDefault(__webpack_require__(/*! react-animate-height */ "react-animate-height"));
var utilities_1 = __webpack_require__(/*! @hsl-fi/utilities */ "@hsl-fi/utilities");
var TextInputError_module_scss_1 = __importDefault(__webpack_require__(/*! ./TextInputError.module.scss */ "./packages/text-input-error/src/TextInputError.module.scss"));
var TextInputError = function (_a) {
    var className = _a.className, visible = _a.visible, text = _a.text, children = _a.children;
    var classList = utilities_1.PropertyUtilities.classList;
    return (react_1.default.createElement("div", { className: classList(TextInputError_module_scss_1.default.textInputError, className && className, visible && TextInputError_module_scss_1.default.textInputErrorFadeIn, !visible && TextInputError_module_scss_1.default.textInputErrorFadeOut), "aria-live": "assertive" }, (children || text) && (react_1.default.createElement(react_animate_height_1.default, { duration: 200, height: visible ? 'auto' : 0 }, children ? children : text))));
};
exports.default = TextInputError;


/***/ }),

/***/ "./packages/text-input-error/src/index.ts":
/*!************************************************!*\
  !*** ./packages/text-input-error/src/index.ts ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TextInputError_1 = __importDefault(__webpack_require__(/*! ./TextInputError */ "./packages/text-input-error/src/TextInputError.tsx"));
exports.default = TextInputError_1.default;


/***/ }),

/***/ "@hsl-fi/utilities":
/*!************************************!*\
  !*** external "@hsl-fi/utilities" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@hsl-fi/utilities");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react-animate-height":
/*!***************************************!*\
  !*** external "react-animate-height" ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-animate-height");

/***/ })

/******/ });
});
//# sourceMappingURL=index.js.map